module.exports = __webpack_public_path__ + "img/740.4a04d888.jpg";